import Draggable from "react-draggable";
import { useSelector } from "react-redux";
import { useRef } from "react";
import { panelPublicUrl } from "../../../../panelurl";
import { CloseSvg } from "../../assets/icons/Icons";

const PresimPanel = ({ panelType, header, icon, closePanel }) => {
    const panelRef = useRef(null);

    const selectedSatellite = useSelector(state => state.unifiedControlPlane.presimData.selectedSatellite);
    const panelUrls = useSelector(state => state.unifiedControlPlane.presimData.predictionData[selectedSatellite.value.satId].data);

    return (
        <Draggable>
            <div className="presim-panel" ref={panelRef}>
                <div className="presim-panel-header">
                    <div className="presim-panel-heading">
                        <span>{icon}</span>
                        <span className="presim-panel-heading-text">{header}</span>
                    </div>
                    <div className="close-icon" onClick={closePanel}>
                        <CloseSvg />
                    </div>
                </div>
                <div className="presim-panel-body">
                    {panelUrls && panelUrls[panelType]?.length > 0 && panelUrls[panelType].map((item, index) => (
                        <div className='presim-panel-body-item' key={index} >
                            <div className="presim-item-label">{item.panel_name}</div>
                            <iframe
                                title="presim-panel-iframe"
                                src={`${panelPublicUrl}${item.url}`}
                                marginHeight="0"
                                loading="lazy"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </Draggable>
    );
};

export default PresimPanel;
